const vectorStyle = (width?: string | number) => ({
  width: width || '100%',
  height: '100%',
  display: 'block',
})
export default vectorStyle
